import React					from "react";
import ReactCSSTransitionGroup	from "react-addons-css-transition-group";

import {
	PrimaryButton,
	SecondaryButton,
	ButtonsBlock,
} from '../../Ui'

const RoleFormConfirmation = ({ isOpen, name, onCancel, onConfirm }) =>
	<ReactCSSTransitionGroup
		transitionName="a-fade"
		transitionEnterTimeout={500}
		transitionLeaveTimeout={500}>
			{isOpen ?
				<div className="c-role-form-confirm u-bg-opaque-white u-flex u-flex--justify-center border-top">
					<div className="bg-primary border-x u-flex a-slide--left">
						<p className="u-flex u-flex--align-items-center p-15-30 u-text-center">Êtes-vous sûre de vouloir supprimer le rôle "{name}" ?</p>

						<div className="u-flex u-flex--align-items-center">
							<ButtonsBlock>
								<SecondaryButton
									onClick={onCancel}>

									Annuler
								</SecondaryButton>
								<PrimaryButton
									onClick={onConfirm}>

									Supprimer
								</PrimaryButton>
							</ButtonsBlock>
						</div>
					</div>
				</div>
			:null}
	</ReactCSSTransitionGroup>

export default RoleFormConfirmation;



// WEBPACK FOOTER //
// ./src/js/plan/roles/RoleFormConfirmation.js